'use strict';

module.exports.classic = require('./classic');



//////////////////
// WEBPACK FOOTER
// ./src/syntax/index.js
// module id = 31
// module chunks = 0